import React, { useEffect, useState } from "react";
import AccordionComponent from "../../../../common/Accordion";
import {
  Button,
  Col,
  Container,
  Row,
  Modal,
  ToggleButton,
  ToggleButtonGroup,
  Form,
  InputGroup,
} from "react-bootstrap";
import TextInput from "../../../../common/TextInput";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import SearchableMultiSelectDropdown from "../../../../common/SearchableMultiSelectDropdown";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import {
  getUserMappingUserListByRoleID,
  getTeamIdByUserId,
} from "../../../../services/TeamsUserMapping";
import {
  EDITOR_REPORT_STATUS,
  PARTY_TYPES,
  PICKLIST_GROUP_NAME,
  QME_DOCTOR_DOCUMENT_TYPES,
  STAKEHOLDER_TYPE,
} from "../../../../common/Constant";
import { fetchPickListByGroupName } from "../../../../services/UserRegistrationApi";
import Snackbar from "../../../../common/Snackbar";
import FloatingLabelDatepicker from "../../../../common/DatePicker";
import EditableFileTable from "../../../../common/CaseNotesTable";
import {
  addCaseNotes,
  fetchNotesCategoryList,
  getDocumentCategoryList,
} from "../../../../services/CaseNotesApi";
import {
  fetchDocumentCategoryList,
  fetchDocumentTypeListForHRE,
  fetchDocumentTypeListForReviewer,
} from "../../../../services/UploadRecordsApi";
import {
  fetchPartiesDetails,
  fetchSenderListForTODO,
} from "../../../../services/CaseInformationApi";
import Loader from "../../../../common/Loader";
import {
  editorReportStatusUpdate,
  GetNotesCategoryByUser,
} from "../../../../services/EditorWorkFlowAPI";

interface PartyProps {
  showDrawer: boolean;
  onClose: () => void;
  caseInfoId: any;
  caseId: any;
  subjectQmeScheduleID: any;
  isRowActionTriggered: any;
  onNotesSaved: () => void;
  details: string;
}
interface PartyOption {
  value: string;
  label: string;
  partyCode: string;
}

interface EmployeeData {
  userid: number;
  userfullname: string;
  userTypeName: string;
}
interface GroupedOption {
  group: string;
  options: { label: string; value: number; disabled?: boolean }[];
}
const DoctorAddNotes: React.FC<PartyProps> = ({
  showDrawer,
  onClose,
  caseInfoId,
  caseId,
  subjectQmeScheduleID,
  isRowActionTriggered,
  onNotesSaved,
  details
}) => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const { isUploadFile } = useSelector((state: RootState) => state.caseHeader);
  const [entityName, setEntityName] = useState("");
  const [showEntityName, setShowEntityName] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const { caseid, claimnumber,patientDetails,CaseTypeName, status, caseStage} =
        useSelector((state: RootState) => state.caseHeader);
  const [partyOption, setPartyOption] = useState<
    { value: string; label: string }[]
  >([]);
   const [selectedUser, setSelectedUser] = useState<(string | number)[]>(
        [],
      );
       const [teamId, setTeamId] = useState<number | null>(null);
       const [userRoleOptions, setUserRoleOptions] = useState<any[]>([]);
  const [partyType, setPartyType] = useState<any>("");
  const [comments, setComments] = useState<string>("");
  const [result, setResult] = useState<any>({});
  const [isCancel, setIsCancel] = useState<boolean>(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState<boolean | undefined>(
    false
  );

  const [documentCategoryOptions, setDocumentCategoryOptions] = useState<any[]>(
    []
  );
  const [documentCategory, setDocumentCategory] = useState<
    string | null | number
  >(null);
  const [documentTypeOptions, setDocumentTypeOptions] = useState<
    {
      value: string;
      label: string;
      documentCategory: string;
      documentTypeDescription: string;
    }[]
  >([]);
  const [documentType, setDocumentType] = useState<string | null | number>(
    null
  );
  const [senderOptions, setSenderOptions] = useState<PartyOption[]>([]);
  const [sender, setSender] = useState<string | null | number>(null);
  const [senderCode, setSenderCode] = useState<string>("");

  const [contactUserOptions, setContactUserOptions] = useState<GroupedOption[]>(
    []
  );
  const [isActive, setIsActive] = useState(true);
  const [activeKey, setActiveKey] = useState<string | null>("0");

  const [addnotefileKey, setaddnotefileKey] = useState<string | null>("0");
  const [partyHeaderID, setPartyHeaderID] = useState<any>("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [fileIds, setFileIds] = useState<string[]>([]);
  const [isRushNotes, setIsRushNotes] = useState<boolean>(false);
  const [rushNoteType, setRushNoteType] = useState<string>("Always Visible");
  const [rushDays, setRushDays] = useState<string | number>("");
  const [showModalNew, setShowModalNew] = useState<boolean>(false);
  const [isSpecialCategory, setIsSpecialCategory] = useState(false);
  const [isOnSaveDisable, setIsOnSaveDisable] = useState<boolean>(false);
  const [documentName, setDocumentName] = useState("");
  const specialLabels = ["Pending No Response", "Missing Phone Number"];

  const params = {
    parties: {
      groupName: PICKLIST_GROUP_NAME.Notes_Category,
      triggerById: loggedInUserid,
    },
  };

  useEffect(() => {
  initializeData();
}, []);

const initializeData = async () => {
  try {
    const response = await getTeamIdByUserId();
    setTeamId(response.teamID);
    const params = {
      teamId: response.teamID,
      roleIds: null,
      userIdException: null,
    };

    const userList = await getUserMappingUserListByRoleID(params);
    setUserRoleOptions(userList || []);

   if (response.userIDs) {
  const ids = response.userIDs
    .split(",")
    .map((id: string) => Number(id.trim()));
  setSelectedUser(ids);
}
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsOnSaveDisable(false);
        const data = await fetchDocumentTypeListForHRE();
        setDocumentTypeOptions(data || []);
        const partiesList = await fetchSenderListForTODO(caseInfoId);
        setSenderOptions(partiesList || []);
        const selectedParty = partiesList?.find(
          (item: any) => item.value === String(loggedInUserid)
        );
        if (selectedParty) {
          setSender(selectedParty.value || null);
          setSenderCode(selectedParty?.partyCode || "");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const loadDocumentCategoryList = async () => {
      try {
        // const data = await fetchPickListByGroupName(params.parties);
        const data = await GetNotesCategoryByUser();
        setDocumentCategoryOptions(data);
      } catch (error) {
        console.error("Failed to fetch document category list:", error);
      }
    };

    loadDocumentCategoryList();
  }, []);

  useEffect(() => {
    if (documentType) {
      const found = documentTypeOptions.find(
        (doc) => doc.value === documentType
      );
      if (found) {
        setDocumentName(found.label);
      }
    }
  }, [documentType]);

  const renderAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
        title:
          activeKey === index.toString() ? (
            item.title
          ) : (
            <>
              {item.title}
              <span className="fw-normal">
                {showEntityName ? ` - ${showEntityName} ` : ""}
              </span>
            </>
          ),
      }))}
      activeKey={activeKey}
      onSelect={(key) => setActiveKey(key as string)}
    />
  );

  const addnotefileAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
        title:
          activeKey === index.toString() ? (
            item.title
          ) : (
            <>
              {item.title}
              <span className="fw-normal">
                {showEntityName ? ` - ${showEntityName} ` : ""}
              </span>
            </>
          ),
      }))}
      activeKey={addnotefileKey}
      onSelect={(key) => setaddnotefileKey(key as string)}
    />
  );

  const [currentDate, setcurrentDate] = useState<Date | null>(null);
  const today = new Date().toISOString().split("T")[0];
  const handleFileIdsUpdate = (ids: string[], isSaveDisabled?: boolean) => {
    setFileIds(ids);
    setIsSaveDisabled(isSaveDisabled);
  };
  useEffect(() => {
    setcurrentDate(new Date()); // Set today's date on initial mount
  }, []);

  const validateForm = () => {
    const errors = [];

    if (!documentCategory) {
      errors.push("Please Select Category.");
    }

    if (!comments) {
      errors.push("Please add Notes");
    }

    const hasAttachments = fileIds && fileIds.length > 0;

    if (!hasAttachments && documentType && sender) {
      errors.push("Please upload attachments.");
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const handleSave = async () => {
    try {
      if (!validateForm()) return;
      setIsOnSaveDisable(true);
      setLoading(true);
      const payload = {
        caseInfoId: caseInfoId,
        subjectQmeScheduleID: subjectQmeScheduleID,
        userId: loggedInUserid,
        noteDate: currentDate ? currentDate.toISOString().split("T")[0] : null,
        noteCategoryId: documentCategory,
        noteContent: comments,
        provisionalAttachmentIds: isSpecialCategory
          ? ""
          : fileIds?.join(",") || "",
        isRushNote: isRushNotes,
        documentTypeId: isSpecialCategory ? null : documentType || null,
        senderKeyId: isSpecialCategory ? null : Number(sender) || null,
        senderKeyCode: isSpecialCategory ? null : senderCode || "",
        isAlwaysVisible: isRushNotes && rushNoteType === "Always Visible" ? 1 : 0,
        noOfVisibilityDays:
          isRushNotes && rushNoteType === "No. of Days"
            ? Number(rushDays)
            : null,
             UserAccessIDs : selectedUser?.length > 0 ? selectedUser.join(",") : null,
             IsBlink: isRushNotes ? 1 : 0,
      };

      const payloadReport = {
        subjectQmeScheduleID: subjectQmeScheduleID,
        reportStatus: EDITOR_REPORT_STATUS.COMPLETED,
      };

      const response = await addCaseNotes(payload);

      if (response.isSuccess) {
        if (
          documentName?.trim() ===
            QME_DOCTOR_DOCUMENT_TYPES.SUPPLEMENTAL_REPORT ||
          documentName?.trim() ===
            QME_DOCTOR_DOCUMENT_TYPES.INITIAL_EVALUATION_REPORT ||
          documentName?.trim() ===
            QME_DOCTOR_DOCUMENT_TYPES.RE_EVALUATION_REPORT ||
          documentName?.trim() === QME_DOCTOR_DOCUMENT_TYPES.SIBTF_REPORT ||
          documentName?.trim() === QME_DOCTOR_DOCUMENT_TYPES.QME_FINAL_REPORT
        ) {
          await editorReportStatusUpdate(payloadReport);
        }
        setSnackbarMessage("Case note added successfully.");
        setError("success");
        setSnackbarOpen(true);

        onNotesSaved?.();
      } else {
        setIsOnSaveDisable(false);
        setSnackbarMessage(response.message || "Failed to add case note.");
        setError("error");
        setSnackbarOpen(true);
      }
      await new Promise((resolve) => setTimeout(resolve, 1500));
      onClose();
    } catch (error: any) {
      setIsOnSaveDisable(false);
      setSnackbarMessage(error.message);
      setError("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelButton = () => {
    setShowModalNew(true);
  };
  const handleCloseModalNew = () => {
    setShowModalNew(false);
  };
  const handleConfirmCancelButton = async () => {
    setIsCancel(true);
    setShowModalNew(false);
    setDocumentCategory(null);
    setComments("");
    setFileIds([]);
    setIsRushNotes(false);
    setRushNoteType("Always Visible");
    setRushDays("");
    setSnackbarOpen(false);
    setSnackbarMessage("");
    setResult([]);
  };

  return (
    <>
      <Container fluid className="px-1">
        <Loader isLoading={loading} />
        <Snackbar
          open={snackbarOpen}
          message={snackbarMessage}
          onClose={() => setSnackbarOpen(false)}
          severity={error}
        />
        {renderAccordion([
          {
            title: "Details",
            content: (
              <div>
                <Row>
                  <Col sm={6}>
                    <FloatingLabelDatepicker
                      label="Date"
                      name="Date"
                      value={currentDate}
                      maxDate={today}
                      onChange={(date: Date | null) => setcurrentDate(date)}
                      required
                      dateFormat="MM/dd/yyyy"
                      disabled
                    />
                  </Col>
                  <Col sm={6}>
                    <TextInput
                       label="Patient"
                      name="Patient"
                      // required
                      value={details}
                      maxLength={100}
                      disabled
                    />
                  </Col>
                  <Col sm={12} className="selection_dropdown mt-4">
                    <SearchableSingleSelectDropdown
                      label="Category"
                      name="documentCategory"
                      options={documentCategoryOptions}
                      value={documentCategory}
                      onChange={(e) => {
                        setDocumentCategory(Number(e.target.value));
                        const selectedValue = Number(e.target.value);
                        const selectedOption = documentCategoryOptions.find(
                          (item) => item.value === selectedValue
                        );
                        const isSpecial = specialLabels.includes(
                          selectedOption?.label
                        );
                        setIsSpecialCategory(isSpecial);
                      }}
                      required
                    />
                  </Col>
                  <Col
                    sm={12}
                    className="mt-3 notemultiline notemultilinerushnote mb-3"
                  >
                    <MultilineTextBox
                      label="Note"
                      style={{ minHeight: "100px" }}
                      name="comments"
                      value={comments}
                      onChange={(e) => {
                        let value = e.target.value;
                        if (value.startsWith(" ")) return;
                        value = value?.trimStart();
                        value = value.replace(/ {2,}/g, " ");
                        setComments(value);
                      }}
                      maxLength={5000}
                      required
                    />
                  </Col>
                  <Col sm={12}>
                    <div className="d-flex align-items-center">
                      <div className="form-check ps-2 d-flex align-items-center">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="Isactive"
                          name="Isactive"
                          checked={isRushNotes}
                          onChange={(e) => setIsRushNotes(e.target.checked)}
                          style={{
                            cursor: "pointer",
                            marginRight: "6px",
                          }}
                        />
                        <span className="material-symbols-outlined rushicon-new me-2">
                          sprint
                        </span>
                        <label
                          className="form-check-label mb-0 me-3 fw-semibold"
                          htmlFor="Isactive"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          Is Rush Note?
                        </label>
                      </div>
<Col
                                          xs={3}
                                          sm={3}
                                          lg={3}
                                          className="col-md-3 selection_dropdown adj_label_lt"
                                        >
                                          <SearchableMultiSelectDropdown
                                            label="User"
                                            name="Roleids"
                                            options={userRoleOptions}
                                             values={selectedUser}
                                  onChange={(e, name, values) =>
                                    setSelectedUser(values)
                                  }
                                          />
                                        </Col>
                      {isRushNotes && (
                        <div className="d-flex align-items-center ms-3">
                          <ToggleButtonGroup
                            type="radio"
                            name="rushNoteType"
                            value={rushNoteType}
                            onChange={(val) => setRushNoteType(val)}
                            className="appointment-ui adjust_pills_xs"
                          >
                            <ToggleButton
                              id="always-visible"
                              variant="outline-secondary"
                              value="Always Visible"
                              className="px-3"
                            >
                              Always Visible
                            </ToggleButton>

                            <ToggleButton
                              id="no-of-days"
                              variant="outline-secondary"
                              value="No. of Days"
                              className="px-3"
                            >
                              No. of Days
                            </ToggleButton>
                          </ToggleButtonGroup>

                          {rushNoteType === "No. of Days" && (
                            <div style={{ width: "160px" }} className="ms-2">
                              <InputGroup size="sm">
                                <Form.Control
                                  type="text"
                                  name="rushDays"
                                  value={rushDays}
                                  onChange={(e: any) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                      setRushDays(value);
                                    }
                                  }}
                                  maxLength={3}
                                  style={{
                                    height: "30px",
                                    fontSize: "12px",
                                    border: "1px solid #ced4da",
                                  }}
                                />
                                <InputGroup.Text
                                  className="bg-light text-muted"
                                  style={{
                                    height: "30px",
                                    fontSize: "11px",
                                    border: "1px solid #ced4da",
                                    borderLeft: "0",
                                  }}
                                >
                                  No. of Days
                                </InputGroup.Text>
                              </InputGroup>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            ),
          },
        ])}

        {!isSpecialCategory &&
          addnotefileAccordion([
            {
              title: "Attachment(s)",
              content: (
                <>
                  <Row>
                    <Col sm={6} className="selection_dropdown">
                      <SearchableSingleSelectDropdown
                        label="Document Type"
                        name="documentType"
                        options={documentTypeOptions}
                        value={documentType}
                        onChange={(e, name, value) => {
                          setDocumentType(value);
                        }}
                      />
                    </Col>
                    <Col sm={6} className="selection_dropdown">
                      <SearchableSingleSelectDropdown
                        label="Sender"
                        name="sender"
                        options={senderOptions}
                        value={sender}
                        onChange={(e, name, value) => {
                          setSender(value);
                          const selectedCode = senderOptions?.find(
                            (item) => item.value === value
                          );
                          if (selectedCode) {
                            setSenderCode(selectedCode?.partyCode || "");
                          }
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className="align-items-center mt-3">
                    <EditableFileTable
                      caseInfoId={caseInfoId}
                      comments={comments}
                      onFileIdsUpdate={handleFileIdsUpdate}
                      result={result}
                      isCancel={isCancel}
                      documentType={documentCategory}
                      //documentType={documentType}
                      isRowActionTriggered={isRowActionTriggered}
                    />
                  </Row>
                </>
              ),
            },
          ])}

        <Row id="team-form-buttons" className="bottom-fixed-btn">
          <Col md={6} className="d-flex justify-content-start mb-2 ">
            {/* <Button
              variant='outline'
              className='btn d-flex align-items-center btn-text-border'
            >
              <span className='material-icons mr-1 '>arrow_back</span>
              Back
            </Button>*/}
          </Col>
          <Col md={6} className="d-flex justify-content-end mb-2 px-0 pe-3">
            <Button
              variant="outline-info"
              className="d-flex align-items-center"
              onClick={handleCancelButton}
              disabled={
                (showDrawer && isUploadFile) ||
                isSaveDisabled ||
                isOnSaveDisable
              }
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>
            <Button
              variant="primary"
              className="ms-3 d-flex align-items-center"
              onClick={handleSave}
              disabled={
                (showDrawer && isUploadFile) ||
                isSaveDisabled ||
                isOnSaveDisable
              }
            >
              <span className="material-icons mx-1">save</span> Save
            </Button>
          </Col>
        </Row>
      </Container>
      <Modal show={showModalNew} onHide={handleCloseModalNew}>
        <Modal.Body className="fw-bold text-left modelheading ">
          <div>Are you sure you want to cancel?</div>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-end"
            onClick={handleCloseModalNew}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            onClick={handleConfirmCancelButton}
            variant="primary"
            className="ms-3 d-flex align-items-center"
          >
            <span className="material-icons mx-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DoctorAddNotes;
